// const baseUrl = 'http://47.101.40.246:9001'
const baseUrl = 'https://goldenidea.radiometer.cn'
// const baseUrl = 'http://192.168.0.129:9001'
const ossBaseUrl = 'https://retail-terminal-management.oss-cn-shanghai.aliyuncs.com/terminal-admin/'

export {
  baseUrl,
  ossBaseUrl
}
